// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","597":"projects"}[chunkId] + "." + {"594":"8fc497a0","597":"3f4b4d56"}[chunkId] + ".js";
};